import React from 'react';

import styled from 'styled-components';

import AddIcon from '../../../common/Icons/AddIcon';
import Button from '../../lib/Button';

const StyledButton = styled(Button)`
  display: flex;
`;

const Label = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: var(--font-bold);
  color: var(--text-primary);
  font-size: 14px;
  gap: 4px;
`;

interface Props {
  label: string;
  onClick: () => void;
  dataTestId?: string;
}

const ShopDataModalAddButton = ({ label, onClick, dataTestId }: Props) => {
  return (
    <StyledButton style={{ height: 40, width: 180 }} onClick={onClick} data-test-id={dataTestId}>
      <Label>
        <AddIcon size={24} />
        <span>{label}</span>
      </Label>
    </StyledButton>
  );
};

export default ShopDataModalAddButton;
